import React, { useState, useCallback } from 'react';

import {
	Checkbox,
    useAjax,
    XhrStatus
} from '@bosch/bt-ui';

import './FlaggedCheckBox.css';
import withErrorHandler from '../../../components/ErrorHandler';
import RestfulCallout from '../../../components/RestfulCallout';
import ConfirmDialog from '../../../components/ConfirmDialog';
import { useNavigate } from 'react-router-dom';

const FlaggedCheckBox = (props) => {
    const {
        token,
        isLoggedIn,
        flaggedInfo
      } = props;

    const [flagged, setFlagged] = useState(flaggedInfo.flagged);
    const [openConfirm, setConfirmOpen] = useState(false);
    const [result, status, runAjaxInner, response] = useAjax(XhrStatus.Initial);
    const navigate = useNavigate();

    const onOpenModal = () => setConfirmOpen(true);
    const onFormSubmit = useCallback(
		() => {
			// If useAjax(XhrStatus.InProgress) and not login yet, it will show 401
			// So we need to make sure token is avaliable to continue...
			if (token?.token) {
				if(isLoggedIn()) {
                    const headers = {
                        'Authorization': 'Bearer ' + token.token
                    }
                    const restfulAction = flaggedInfo.flagged ? 'DELETE' : 'POST';
                    runAjaxInner(restfulAction, SUPPORTCONSOLE_API_URL + '/api/panelmanagement/v1/devicemigration/' + encodeURIComponent(flaggedInfo.cloudId), null, null, headers);

                    if (flaggedInfo.flagged)
                    {
                        flaggedInfo.flagged = false;
                        setFlagged(false);
                    }
                    else
                    {
                        flaggedInfo.flagged = true;
                        setFlagged(true);
                    }
				}
				else {
					navigate('/');
				}
			}
            setConfirmOpen(false);
		},
		[token, isLoggedIn, flaggedInfo, runAjaxInner, navigate]
	);

    return (
        <div id="flagged-checkbox">
            <Checkbox
                fieldName="flagged"
                htmlAttributes={{
                    onClick: onOpenModal,
                    checked: flagged ?? false
                }}
            />
            <ConfirmDialog openConfirm={openConfirm} descTranslatedId={'panel-disable-warning'} setConfirmOpen={setConfirmOpen} onConfirm={onFormSubmit} />
            <RestfulCallout status={status} response={response} returnObj={result}/>
        </div>
    );
  };

export default withErrorHandler(React.memo(FlaggedCheckBox));